export const CONSULTANT_ROLES = ['CALL_CENTER_MANAGER', 'CALL_CENTER_OPERATOR'];
export const CONSULTANT_MANAGER_ROLES = ['CALL_CENTER_MANAGER'];
